/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_As as As,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_js as js,
  rec_ks as ks,
  rec_xs as xs,
} from "../../runtime/index.jsx";
export function TransicionMarca(e) {
  let t = (0, ReactCompiler.c)(18),
    { onDone: n, modo: r, mensaje: i } = e,
    a = r === void 0 ? `abrir` : r,
    [o, s] = (0, React.useState)(a === `abrir`),
    [c, l] = (0, React.useState)(!1),
    u,
    f;
  (t[0] !== a || t[1] !== n
    ? ((u = () => {
        if (window.matchMedia?.(`(prefers-reduced-motion: reduce)`).matches) {
          let e = setTimeout(n, 50);
          return () => clearTimeout(e);
        }
        if (a === `abrir`) {
          let e = requestAnimationFrame(() => l(!0)),
            t = setTimeout(() => {
              (l(!1), s(!1));
            }, As),
            r = setTimeout(n, 1400);
          return () => {
            (cancelAnimationFrame(e), clearTimeout(t), clearTimeout(r));
          };
        }
        let e = requestAnimationFrame(() => s(!0)),
          t = setTimeout(() => l(!0), js),
          r = setTimeout(n, 1400);
        return () => {
          (cancelAnimationFrame(e), clearTimeout(t), clearTimeout(r));
        };
      }),
      (f = [a, n]),
      (t[0] = a),
      (t[1] = n),
      (t[2] = u),
      (t[3] = f))
    : ((u = t[2]), (f = t[3])),
    (0, React.useEffect)(u, f));
  let p = `absolute inset-y-0 left-0 w-1/2 bg-(--accent) transition-transform duration-700 ease-in-out ${o ? `translate-x-0` : `-translate-x-full`}`,
    m;
  t[4] === p
    ? (m = t[5])
    : ((m = <div className={p} />), (t[4] = p), (t[5] = m));
  let h = `absolute inset-y-0 right-0 w-1/2 bg-(--accent) transition-transform duration-700 ease-in-out ${o ? `translate-x-0` : `translate-x-full`}`,
    _;
  t[6] === h
    ? (_ = t[7])
    : ((_ = <div className={h} />), (t[6] = h), (t[7] = _));
  let v = `absolute inset-0 flex flex-col items-center justify-center gap-4 transition-opacity duration-300 ${c ? `opacity-100` : `opacity-0`}`,
    y;
  t[8] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((y = (
        <img
          src={xs(`TRANSICION`, xs(`PRINCIPAL`, ks))}
          alt={``}
          className={`h-16 w-auto brightness-0 invert`}
        />
      )),
      (t[8] = y))
    : (y = t[8]);
  let b;
  t[9] === i
    ? (b = t[10])
    : ((b = i && (
        <p className={`text-sm font-medium text-(--accent-fg)`} children={i} />
      )),
      (t[9] = i),
      (t[10] = b));
  let x;
  t[11] !== b || t[12] !== v
    ? ((x = <div className={v} children={[y, b]} />),
      (t[11] = b),
      (t[12] = v),
      (t[13] = x))
    : (x = t[13]);
  let S;
  return (
    t[14] !== x || t[15] !== m || t[16] !== _
      ? ((S = (
          <div
            className={`fixed inset-0 z-50`}
            aria-hidden={`true`}
            children={[m, _, x]}
          />
        )),
        (t[14] = x),
        (t[15] = m),
        (t[16] = _),
        (t[17] = S))
      : (S = t[17]),
    S
  );
}
